export default __webpack_public_path__ + "static/media/13-2_close.1a648de0.svg";